import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { ProfileService } from '../profile/profile.service';
import { NavBarComponent } from './nav-bar/nav-bar.component';

@Component({
  imports: [NavBarComponent, RouterModule],
  selector: 'app-top-bar',
  styles: ``,
  templateUrl: './top-bar.component.html',
})
export class TopBarComponent {
  public profileSrv = inject(ProfileService);
  public router = inject(Router);

  logout() {
    this.profileSrv.logoutBlacklist().subscribe();
  }
}
